import { getDataIngestionData, getExportDataIngestionHistory } from '@/services/dataIngestionHistory';
// fetch and format table
export const fetchDataIngestionHistory = ({ limit, page }) => getDataIngestionData({
    limit,
    page,
    home: 0,
}).then(response => formatAvailableTables(response?.data));
const formatAvailableTables = (response) => ({
    data: response?.data,
    errors: response?.errors,
    success: response?.success,
    totalCount: response?.totalCount,
    series: response?.series,
    warnings: response?.warnings,
});
// export data ingestion history
export const exportDataIngestionHistory = (date, fileType, responseType) => getExportDataIngestionHistory({ fileType, responseType, date }).then(response => formatExport(response?.data));
const formatExport = (response) => response;
